import React, { useEffect, useState } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, CircularProgress } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import WindowsIcon from '@mui/icons-material/Microsoft';
import AppleIcon from '@mui/icons-material/Apple';
import LinuxIcon from '@mui/icons-material/Terminal';
import { authFetch } from '../utils/authFetch';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function formatBytes(bytes) {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

function getOsIcon(filename) {
  const lower = filename.toLowerCase();
  if (lower.includes('win')) return <WindowsIcon titleAccess="Windows" color="primary" />;
  if (lower.includes('linux')) return <LinuxIcon titleAccess="Linux" color="primary" />;
  if (lower.includes('mac') || lower.includes('osx') || lower.includes('darwin')) return <AppleIcon titleAccess="macOS" color="primary" />;
  return null;
}

export default function DownloadsPage() {
  const [files, setFiles] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    authFetch(`${BACKEND_URL}/downloads/`)
      .then(res => res.ok ? res.json() : Promise.reject(res))
      .then(setFiles)
      .catch(() => setError('Failed to fetch downloads.'))
      .finally(() => setLoading(false));
  }, []);

  const handleDownload = (filename) => {
    authFetch(`${BACKEND_URL}/downloads/${encodeURIComponent(filename)}`)
      .then(res => {
        if (!res.ok) throw new Error('Download failed');
        return res.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => setError('Failed to download file.'));
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h2" gutterBottom>Agent Downloads</Typography>
      {loading ? <CircularProgress /> : error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <TableContainer component={Paper} sx={{ width: '100%' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Filename</TableCell>
                <TableCell>OS</TableCell>
                <TableCell>Size</TableCell>
                <TableCell>Last Modified</TableCell>
                <TableCell>Download</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {files.map(file => (
                <TableRow key={file.filename}>
                  <TableCell>{file.filename}</TableCell>
                  <TableCell>{getOsIcon(file.filename)}</TableCell>
                  <TableCell>{formatBytes(file.size)}</TableCell>
                  <TableCell>{new Date(file.modified * 1000).toLocaleString()}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<CloudDownloadIcon />}
                      onClick={() => handleDownload(file.filename)}
                    >
                      Download
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
